export const useStyles = theme => ({
  rightContainerRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    [theme.breakpoints.down('md')]: {
      alignItems: 'start',
      marginTop: '40px',
    },
  },
  dashboardDetails: {
    color: '#fff',
    fontFamily: 'Maax-Medium',
  },
  dashboardDraftDetails: {
    marginTop: '20px',
    textAlign: 'end',
    color: '#F0B310 !important',
    font: 'normal 900 20px/29px Maax-Black',
    [theme.breakpoints.down('md')]: {
      textAlign: 'unset',
      font: 'normal normal 900 15px/20px Maax-Black',
    },
  },
  score: {
    font: 'normal normal 900 120px/144px Maax-Black',
    [theme.breakpoints.down('md')]: {
      font: 'normal normal 900 100px/100px Maax-Black',
    },
  },
  terms: {
    color: '#fff !important',
    fontStyle: 'italic',
    fontFamily: 'Maax-BoldItalic',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    marginTop: '5px',
  },
  draftButtonContainer: {
    textAlign: 'end',
    [theme.breakpoints.down('md')]: {
      textAlign: 'unset',
    },
  },
  button: {
    color: '#0D6A41',
    backgroundColor: '#B4C64C',
    width: '60%',
    borderRadius: '10px',
    font: 'normal normal 20px/36px Maax-Bold',
    marginTop: '5px',
    '&:hover': {
      backgroundColor: '#B4C64C',
    },
  },
});
